import { Module, MutationTree, ActionTree, Store } from 'vuex';

import { RootState } from '@/store/types';
import { registerSubModule } from '@/utils/vueUtils';
import { UnsubscribeEmail, UnsubscribeDerEmail, getAllEmailsList } from './UnsubscribeModule.api';
import {
  DerUnsubscribeList,
  DerUnsubscribeViewModel,
} from '@/modules/UnsubscribeModule/UnsubscribeModule.types';

export interface UnsubscribeModuleState {
  List: DerUnsubscribeList[];
  IsSubmitted: boolean;
  ShowAllBtnWasClicked: boolean;
  Message: string;
}

export const SET_LIST = 'SET_LIST';
export const SET_IS_SUBMITTED = 'SET_IS_SUBMITTED';
export const SET_BTN_WAS_CLICKED = 'SET_BTN_WAS_CLICKED';
export const SET_MESSAGE = 'SET_MESSAGE';

const mutations: MutationTree<UnsubscribeModuleState> = {
  [SET_LIST](state, payload) {
    state.List = payload;
  },
  [SET_IS_SUBMITTED](state) {
    state.IsSubmitted = true;
  },
  [SET_BTN_WAS_CLICKED](state) {
    state.ShowAllBtnWasClicked = true;
  },
  [SET_MESSAGE](state, payload) {
    state.Message = payload;
  },
};

export const UNSUBSCRIBE_EMAIL = 'UNSUBSCRIBE_EMAIL';
export const UNSUBSCRIBE_DER_EMAIL = 'UNSUBSCRIBE_DER_EMAIL';
export const GET_LIST = 'GET_LIST';

const actions: ActionTree<UnsubscribeModuleState, RootState> = {
  async [GET_LIST]({ state, commit }, data) {
    try {
      const list = await getAllEmailsList(data);
      commit(SET_LIST, list);
      commit(SET_BTN_WAS_CLICKED);
      commit(SET_MESSAGE, '');
    } catch (e) {
      //console.log(e);
    }
  },
  async [UNSUBSCRIBE_EMAIL]({ state, commit }, data) {
    try {
      commit(SET_MESSAGE, '');
      await UnsubscribeEmail(data);
      commit(SET_IS_SUBMITTED);
      commit(SET_MESSAGE, '<span>You have successfully unsubscribed.</span>');
    } catch (e) {
      commit(SET_MESSAGE, '<span>Oops, something went wrong.</span>');
      //console.log(e);
    }
  },
  async [UNSUBSCRIBE_DER_EMAIL]({ state, commit }, data) {
    try {
      commit(SET_MESSAGE, '');
      const resp = await UnsubscribeDerEmail(data);
      if (!resp) {
        commit(SET_MESSAGE, `<span>We couldn't find any subscriptions.</span>`);
        return;
      }
      commit(SET_IS_SUBMITTED);
      if (data && (data.id || data.familyId) && state.List.length) {
        const filteredList = data.id
          ? state.List.filter((item) => item.Id !== data.id)
          : state.List.filter((item) => item.FamilyId !== data.familyId);
        if (filteredList.length !== state.List.length) commit(SET_LIST, filteredList);
      }

      const defaultMessage =
        !data.doNotShowSuccessMessage || !state.List.length
          ? '<span>You have successfully unsubscribed.</span>'
          : '';

      commit(SET_MESSAGE, data.message ? data.message : defaultMessage);
    } catch (e) {
      commit(SET_MESSAGE, '<span>Oops, something went wrong.</span>');
      //console.log(e);
    }
  },
};

const registerModule = registerSubModule<UnsubscribeModuleState, DerUnsubscribeViewModel>(
  (data: DerUnsubscribeViewModel) => {
    return {
      namespaced: true,
      state: {
        List: [],
        IsSubmitted: false,
        ShowAllBtnWasClicked: false,
        Message: '',
      },
      actions,
      mutations,
    } as Module<UnsubscribeModuleState, RootState>;
  },
  'UnsubscribeModule',
);

export default async (store: Store<RootState>, data: DerUnsubscribeViewModel) => {
  return registerModule(store, data);
};
